import { motion } from 'framer-motion';

const startingPoints = [
  'An idea you can\u2019t fully articulate yet',
  'A business challenge that needs fresh thinking',
  'A workflow that feels manual or stuck',
  'A concept you want to see visualized',
  'A question about how AI fits your world',
  'An ambition that needs structure and a next step',
];

const fadeUp = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: '-60px' },
};

export default function BringHere() {
  return (
    <section id="bring" className="py-24 md:py-36" data-testid="bring-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="section-divider mb-12" />

        <motion.p className="section-number" {...fadeUp} data-testid="bring-number">
          02 / Starting Points
        </motion.p>
        <motion.h2
          className="section-title mt-3 mb-4"
          {...fadeUp}
          transition={{ duration: 0.7, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
          data-testid="bring-title"
        >
          What You Can
          <br />
          Bring Here
        </motion.h2>
        <motion.p
          className="text-[var(--cv-text-dim)] text-sm md:text-base max-w-[480px] mb-14 md:mb-20"
          style={{ fontFamily: 'var(--font-body)' }}
          {...fadeUp}
          transition={{ duration: 0.7, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
          data-testid="bring-subtitle"
        >
          You don&apos;t need a pitch deck or a finished plan.
          You just need something worth exploring.
        </motion.p>

        <div className="bring-grid" data-testid="bring-grid">
          {startingPoints.map((point, i) => (
            <motion.div
              key={i}
              className="bring-item"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-40px' }}
              transition={{
                duration: 0.6,
                delay: 0.06 * i,
                ease: [0.16, 1, 0.3, 1],
              }}
              data-testid={`bring-item-${i}`}
            >
              <span className="bring-marker" aria-hidden="true" />
              <span className="bring-text">{point}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
